import React from 'react'
import { Container, Row, Col, Button, FormGroup, Label, Input } from 'reactstrap';
import { Field } from 'redux-form'
import InputRange from 'react-input-range';

import { renderInput, renderSelect, renderRadio, renderInputGroup, renderSelectCheckbox } from '../../utils/forms/renderers'
import { isRequired } from '../../utils/forms/validators'
import Loader from '../../core/components/Loader'
import { ButtonLoader } from '../../utils/loader'
import '../styles/style.css';
import '../styles/form.css';

import 'react-input-range/lib/css/index.css';


function normalizeCheckboxValues(value, previousValue) {
  // only the onChange event returns a string
  if (typeof value !== 'string') return previousValue
  if (!previousValue || !previousValue.length) return [value]
  if (!previousValue.find(val => val === value))
    return [...previousValue, value]
  return previousValue.filter(val => val !== value)
}

class FormStepThree extends React.Component {

	 constructor(props) {
        super(props);

        this.state = {
          value: { min: 2, max: 10 },
        };


    }
    componentDidMount() {
      this.props.listDepartmentByRegion(this.props.provider.provider.region)
      this.props.listSpecialties()
      this.props.listEquipments()
    }

    intervention_time(event){
      // this.props.change('date_status', 'prout')
      console.log(event.target.value)
    }

    renderSpecialities(){
      const { specialties } = this.props

      var sortSpecialties = [];

      if(specialties.fulfilled){
          for (var i = 0; i < specialties.list.length; i++) {
              if (specialties.list[i].name === 'Plomberie') {
                  sortSpecialties.push(specialties.list[i])
                  specialties.list.splice(i, 1);
                  break;
              }
          }
          for (var i = 0; i < specialties.list.length; i++) {
              if (specialties.list[i].name === 'Électricité') {
                  sortSpecialties.push(specialties.list[i])
                  specialties.list.splice(i, 1);
                  break;
              }
          }
          for (var i = 0; i < specialties.list.length; i++) {
              if (specialties.list[i].name === 'Gaz') {
                  sortSpecialties.push(specialties.list[i])
                  specialties.list.splice(i, 1);
                  break;
              }
          }
          for (var i = 0; i < specialties.list.length; i++) {
              sortSpecialties.push(specialties.list[i])
          }
          specialties.list = sortSpecialties;

          return specialties.list.map((specialty) => {
                return (
                    <Col key={specialty.id}>
                         <div className="title2"> {specialty.name} </div>
                         <Field
                            name="skills"
                            customClass = "skills"
                            component={renderSelectCheckbox}
                            options={specialty.skills}
                           />
                    </Col>
                )
          });
        }
    }

    renderEquipments(){
      const { equipments } = this.props
      if(equipments.fulfilled){
          return equipments.list.map((equipment) => {
                return (
                    <Col key={equipment.id}>
                        <div className="title2"> {equipment.name} </div>
                         <Field
                            name="equipments"
                            customClass = "skills"
                            component={renderSelectCheckbox}
                            options={equipment.equipments}
                           />
                    </Col>
                )
          });
        }

    }

    render() {
    	const { provider, closePage } = this.props;
        const { handleSubmit, pristine, submitting, departments, submitSucceeded } = this.props;

    	return (
            <div>
                <form role="form" >
                    <div className="provider-bloc-form">
                        <Row>
                            <Col>
                                <div className="title"> Votre organisation </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                              <Field
                                name="administratives_number"
                                type="number"
                                validate={isRequired}
                                component={renderInput}
                                label="Nombre de salarié(s) administratif(s)*" />
                            </Col>

                            <Col>
                              <Field
                                name="technicians_number"
                                type="number"
                                validate={isRequired}
                                component={renderInput}
                                label="Nombre de technicien(s)*" />
                            </Col>
                          </Row>

                          <Row>
                              <Col>
                                  <FormGroup className="input-radio">
                                    <Label>Jours et horaires d’intervention :*</Label>
                                    <FormGroup check>
                                        <Field
                                          name="intervention_planning"
                                          type="radio"
                                          component={renderRadio}
                                          validate={isRequired}
                                          value="5J/7"
                                          label="Du lundi au vendredi" />
                                          <Field
                                          name="intervention_planning"
                                          type="radio"
                                          value="6J/7"
                                          component={renderRadio}
                                          label="Du lundi au samedi" />
                                          <Field
                                          name="intervention_planning"
                                          type="radio"
                                          value="7J/7"
                                          component={renderRadio}
                                          label="Du lundi au dimanche" />
                                    </FormGroup>
                                  </FormGroup>
                              </Col>
                          </Row>

                          <Row>

                                <Col>
                                    <Field
                                      name="intervention_time_start"
                                      component={renderInputGroup}
                                      validate={isRequired}
                                      type="number"
                                      group="heure de début"
                                      label="Vous souhaitez intervenir sur les horaires :*" />
                                </Col>

                                <Col>
                                    <Field
                                      name="intervention_time_end"
                                      type="number"
                                      component={renderInputGroup}
                                      validate={isRequired}
                                      group="heure de fin" />
                                </Col>

                          </Row>
                        {/*
                        <Row>
                            <Col>
                                <Field
                                    name="range_action"
                                    type="number"
                                    component={renderInput}
                                    label="Rayon d'action (en km)" />
                            </Col>
                        </Row>
                        */}
                        {/*
                          <Row>
                                <Col>
                                    <Field
                                      name="departments"
                                      component={renderSelectCheckbox}
                                      options={departments.list}
                                      validate={isRequired}
                                      label={"Vous souhaitez intervenir sur les départements ("+provider.provider.region_name+") :*"} />
                                </Col>
                          </Row>
                        */}
                          {!this.props.create &&
                            <div>
                              <Row>
                                    <Col>
                                        <div className="separation"> </div>
                                    </Col>
                              </Row>

                              <Row>
                                <Col>
                                    <div className="title"> Tarification </div>
                                </Col>
                              </Row>

                                {/*
                              <Row>
                                  <Col>
                                      <FormGroup className="input-radio">
                                        <Label>Bordereau de prix négocié avec HomeServe</Label>
                                        <FormGroup check>
                                            <Field
                                              name="price_file"
                                              type="radio"
                                              component={renderRadio}
                                              value="True"
                                              label="Oui" />
                                              <Field
                                              name="price_file"
                                              type="radio"
                                              value="False"
                                              component={renderRadio}
                                              label="Non" />
                                        </FormGroup>
                                      </FormGroup>
                                  </Col>
                              </Row>
                                */}
                            </div>
                          }

                          <Row>

                                <Col>
                                    <Field
                                      name="price_1"
                                      component={renderInputGroup}
                                      validate={isRequired}
                                      type="number"
                                      min={0}
                                      group="€ / heure"
                                      label="Journée*" />
                                </Col>

                                <Col>
                                    <Field
                                      name="price_2"
                                      type="number"
                                      validate={isRequired}
                                      component={renderInputGroup}
                                      group="€ / heure"
                                      label="Soirée et Samedi*" />
                                </Col>

                                <Col>
                                    <Field
                                      name="price_3"
                                      type="number"
                                      validate={isRequired}
                                      component={renderInputGroup}
                                      group="€ / heure"
                                      label="Nuit / Dimanche / Jour férié*" />
                                </Col>
                          </Row>

                          <Row>
                                <Col>
                                    <div className="separation"> </div>
                                </Col>
                          </Row>

                          <Row>
                            <Col>
                                <div className="title"> Compétences </div>
                            </Col>
                          </Row>


                          <Row>
                              {this.renderSpecialities()}
                          </Row>

                          <Row>
                                <Col>
                                    <div className="separation"> </div>
                                </Col>
                          </Row>

                          <Row>
                            <Col>
                                <div className="title"> Équipements </div>
                            </Col>
                          </Row>

                          <Row>
                              {this.renderEquipments()}
                          </Row>
                    </div>

                    <div>
                     <Row className="form-btn">

                        {this.props.create &&
                          <Col className="center">

                              <FormGroup>
                                  <Button className="btn-transparent" onClick={() => { this.props.previousPage(); window.scrollTo(0, 0)} }>Etape précédente</Button>

                                  {submitting &&
                                    <ButtonLoader />
                                  ||
                                   <Button className="btn-green" onClick={handleSubmit}>Etape suivante</Button>
                                  }

                            </FormGroup>
                          </Col>
                        }

                        {!this.props.create &&
                          <Col className="center">
                              <FormGroup>
                                <Button className="btn-transparent" onClick={closePage}>{submitSucceeded && "Retour à la fiche" || "Annuler"}</Button>

                                {submitting &&
                                  <ButtonLoader />
                                ||
                                  <Button className="btn-green" onClick={handleSubmit} >Enregistrer</Button>
                                }
                            </FormGroup>
                          </Col>
                        }


                      </Row>
                    </div>

                    <div className="provider-bloc-note">
                        * Champs obligatoires
                    </div>
                    <div className="provider-bloc-note">
                        Les informations recueillies sont nécessaires à HomeServe pour la gestion de votre candidature à notre réseau de prestataires agréé grâce à la création de votre compte prestataire.
                        Pour plus d’informations, consultez notre <a href={"https://homeserve.fr/politique-protection-donnees-personnelles"}> Politique de données personnelles. </a>
                        Conformément à la règlementation, vous bénéficiez d’un droit d’accès, de rectification, de limitation, de portabilité, d’effacement et d’opposition à l’utilisation de vos données personnelles ainsi que du droit de formuler des directives concernant la gestion de vos données post mortem.
                        Vous pouvez exercer ces droits en vous adressant auprès de HomeServe – Service Clients – TSA 82111 – 69303 Lyon Cedex 07 ou par mail à webmestre@homeserve.fr
                    </div>
                </form>
            </div>
        )
    }
}


export default FormStepThree



// WEBPACK FOOTER //
// ./src/provider/components/FormStepThree.js